import styled, { css } from 'styled-components'

import { Alert as BoltAlert } from '@sainsburys-tech/bolt'

const FulfilmentDeliveryContainer = styled.div`
  position: relative;
  margin-bottom: 0;
  background-color: ${props => props.theme.color.monochrome.white};
  border-top: 1px solid ${props => props.theme.color.monochrome.light};
  padding-top: 10px;
  margin-top: 10px;
`
const FulfilmentActionRow = styled.div`
  margin-left: 33px;
  margin-top: 15px;

  a,
  button + span {
    margin-left: 15px;
  }
`
const FulfilmentDeliveryHeader = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 10px;
`
const FulfilmentDeliveryTitle = styled.p`
  &&& {
    padding-left: 8px;
    font-weight: ${props => props.theme.font.weight.bold};
    margin-bottom: 0;
  }
`
const FulfilmentMessagePanel = styled.div`
  padding: 0;
  position: relative;
`
const FulfilmentDeliveryFee = styled.span`
  padding: 5px;
  border-radius: 3px;
  display: block;
  text-align: center;
  margin-top: 10px;
  margin-left: 33px;
  font-weight: ${props => props.theme.font.weight.bold};
  background: ${props => props.theme.color.monochrome.lighter};
`

const FulfilmentEmailPanel = styled.div`
  margin-top: 15px;
  margin-bottom: 25px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  form:nth-child(2) {
    div:first-child {
      margin-bottom: 0px;
      div:first-child {
        margin-bottom: 0px;
      }
    }
  }
`

const FufilmentEmailConfirmation = styled(BoltAlert)`
  padding: 15px;
  margin: 0;

  svg {
    align-self: auto;
  }

  ${props =>
    props.theme.channel === 'habitat' &&
    css`
      color: inherit;
      background: ${props.theme.color.monochrome.lighter};
      font-size: ${props.theme.font.size.root};
    `}
`

export {
  FulfilmentDeliveryContainer,
  FulfilmentActionRow,
  FulfilmentDeliveryHeader,
  FulfilmentDeliveryTitle,
  FulfilmentMessagePanel,
  FulfilmentDeliveryFee,
  FulfilmentEmailPanel,
  FufilmentEmailConfirmation
}
